var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"repairInfo"},[_c('overflowYHidden',[_c('baseInfo',{attrs:{"report":_vm.report}}),_c('timeStep',{attrs:{"stepData":_vm.stepData}}),_c('div',{staticClass:"footer",on:{"click":_vm.submit}},[_vm._v("确定")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }